import script from "./ViewBlogModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewBlogModal.vue?vue&type=script&lang=ts&setup=true"

import "./ViewBlogModal.vue?vue&type=style&index=0&id=96229ed0&lang=css"

const __exports__ = script;

export default __exports__